<!--<div class="pagebrk">
  <printheaderview>
  </printheaderview>
</div>-->
<div class="row">
  <div class="col-print-12 padding-left-0px">
    <div class="card">
      <div class="card-header padding-left-0px border-bottom-0 padding-top-0px padding-bottom-0px"></div>
      <div class="card-body padding-top-0px padding-bottom-0px font-weight-normal">

        <div class="row">
          <div class="col-print-12 text-align-center">
            <label class="font-familyhead">Embryo Grading</label>
            <qrcode class="padding-top-0px padding-bottom-0px qr-style6" [qrdata]="FormattedCode" [size]="90" [level]="'M'"></qrcode>
          </div>
        </div>

        <div class="col-print-12 bordertop border-bot-1px border-bottom-1px">
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-5 margin-top-10 margin-bottom-10px">
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family font-weight-normal">Patient:</label>
                </div>
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family float-left font-weight-bold">{{Owner}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family font-weight-normal">Gender/Age:</label>
                </div>
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{Gender}}/{{Age}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family font-weight-normal">Patient ID:</label>
                </div>
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{FormattedCode}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family font-weight-normal">Infertility Type:</label>
                </div>
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{Infertility}}</label>
                </div>
              </div>
            </div>

            <div class="col-print-1"></div>

            <div class="col-print-5 margin-top-10 margin-bottom-10px">
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family font-weight-normal">Cycle:</label>
                </div>
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{CycleType}} ({{CycleNo}})</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family font-weight-normal">Protocol:</label>
                </div>
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{Protocol}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family font-weight-normal">Protocol Start:</label>
                </div>
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{Protocolst | date:'dd-MMM-yyyy'}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family font-weight-normal">Protocol End:</label>
                </div>
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{ProtocolEd | date:'dd-MMM-yyyy'}}</label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-print-12">
          <div class="row margin-left-0px">
            <div class="col-print-2">
              <label class="margin-bottom-0px font-family font-weight-normal"></label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
            </div>
          </div>
        </div>
        <div class="col-print-12">
          <div class="row margin-left-0px text-center">

            <div class="col-print-3 bordertop border-bot-1px border-right-1px border-left-1px margin-right-10px" *ngFor="let l of CurrentSingleWellCultureByCycleCodeController">
              <div class="row margin-left-0px margin-right-0px border-bot-1px">
                <div class="col-print-4 border-right-1px">
                  <div class="row margin-left-0px margin-right-0px">
                    <div class="col-print-12 text-center">
                      <label class="margin-bottom-0px margin-top-0px font-family font-weight-normal">Well</label>
                    </div>
                  </div>

                  <div class="row margin-left-0px margin-right-0px">
                    <div class="col-print-12 text-center">
                      <label class="margin-bottom-0px margin-top-0px font-family font-weight-bold">{{l.WellNo}}</label>
                    </div>
                  </div>
                </div>
                <div class="col-print-4 border-right-1px">
                  <div class="row margin-left-0px margin-right-0px">
                    <div class="col-print-12 text-center">
                      <label class="margin-bottom-0px margin-top-0px font-family font-weight-normal">Day</label>
                    </div>
                  </div>

                  <div class="row margin-left-0px margin-right-0px">
                    <div class="col-print-12 text-center">
                      <label class="margin-bottom-0px margin-top-0px font-family font-weight-bold">{{GetMaxDOC(l)}}</label>
                    </div>
                  </div>
                </div>
                <div class="col-print-4 padding-left-10px">
                  <div class="row margin-left-0px margin-right-0px">
                    <div class="col-print-12 text-center">
                      <label class="margin-bottom-0px margin-top-0px font-family font-weight-normal">Grade</label>
                    </div>
                  </div>
                  <div class="row margin-left-0px margin-right-0px">
                    <div class="col-print-12 text-center">
                      <label class="margin-bottom-0px margin-top-0px font-family font-weight-bold">{{GetMaxGrade(l)}}</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row margin-left-0px padding-top-10px padding-bottom-10px">
                <div class="col-print-11 text-center">
                  <!--<img class="border-radius-50p nav-link-hand margin-top-10" height="35px" width="35px" [src]="GetMaxImageUrl(l)" onError="this.src='dummy.jpg';">-->
                  <img class="nav-link-hand img5" [src]="GetMaxImageUrl(l)" onError="this.src='Day-5-Embryo.jpg';">
                  <!--<img class="nav-link-hand img5" src="Day-5-Embryo.jpg">-->
                </div>
              </div>
              <div class="row margin-left-0px border-top-1px margin-right-0px">
                <div class="col-print-12 text-center" *ngIf="l.IsFrozen">
                  <label class="margin-bottom-0px margin-top-0px font-family font-weight-normal">Frozen</label>
                </div>
              </div>
            </div>
            <!--<div class="col-print-1"></div>-->
            <div class="col-print-3 bordertop border-bot-1px border-right-1px border-left-1px margin-right-10px" *ngFor="let l of TransferrableList">
              <div class="row margin-left-0px margin-right-0px border-bot-1px">
                <div class="col-print-4 border-right-1px">
                  <div class="row margin-left-0px margin-right-0px">
                    <div class="col-print-12 text-center">
                      <label class="margin-bottom-0px margin-top-0px font-family font-weight-normal">Well</label>
                    </div>
                  </div>

                  <div class="row margin-left-0px margin-right-0px">
                    <div class="col-print-12 text-center">
                      <label class="margin-bottom-0px margin-top-0px font-family font-weight-bold">{{l.WellNo}}</label>
                    </div>
                  </div>
                </div>
                <div class="col-print-4 border-right-1px">
                  <div class="row margin-left-0px margin-right-0px">
                    <div class="col-print-12 text-center">
                      <label class="margin-bottom-0px margin-top-0px font-family font-weight-normal">Day</label>
                    </div>
                  </div>

                  <div class="row margin-left-0px margin-right-0px">
                    <div class="col-print-12 text-center">
                      <label class="margin-bottom-0px margin-top-0px font-family font-weight-bold">{{GetMaxDOC(l)}}</label>
                    </div>
                  </div>
                </div>
                <div class="col-print-4 padding-left-10px">
                  <div class="row margin-left-0px margin-right-0px">
                    <div class="col-print-12 text-center">
                      <label class="margin-bottom-0px margin-top-0px font-family font-weight-normal">Grade</label>
                    </div>
                  </div>
                  <div class="row margin-left-0px margin-right-0px">
                    <div class="col-print-12 text-center">
                      <label class="margin-bottom-0px margin-top-0px font-family font-weight-bold">{{GetMaxGrade(l)}}</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row margin-left-0px padding-top-10px padding-bottom-10px">
                <div class="col-print-11 text-center">
                  <img class="nav-link-hand img5" [src]="GetMaxImageUrl(l)" onError="this.src='Day-5-Embryo.jpg';">
                  <!--<img class="nav-link-hand img5" src="Day-5-Embryo.jpg">-->
                </div>
              </div>
              <div class="row margin-left-0px border-top-1px margin-right-0px">
                <div class="col-print-12 text-center" *ngIf="l.IsTransferrable">
                  <label class="margin-bottom-0px margin-top-0px font-family font-weight-normal">Continuing</label>
                </div>
              </div>
            </div>
            <div class="col-print-1"></div>
            <!--<div class="col-print-3 bordertop border-bot-1px border-right-1px border-left-1px">
              <div class="row margin-left-0px margin-right-0px border-bot-1px">
                <div class="col-print-4 border-right-1px">
                  <div class="row margin-left-0px margin-right-0px">
                    <div class="col-print-12 text-center">
                      <label class="margin-bottom-0px margin-top-0px font-family font-weight-normal">Well</label>
                    </div>
                  </div>

                  <div class="row margin-left-0px margin-right-0px">
                    <div class="col-print-12 text-center">
                      <label class="margin-bottom-0px margin-top-0px font-family font-weight-bold">3</label>
                    </div>
                  </div>
                </div>
                <div class="col-print-4 border-right-1px">
                  <div class="row margin-left-0px margin-right-0px">
                    <div class="col-print-12 text-center">
                      <label class="margin-bottom-0px margin-top-0px font-family font-weight-normal">Day</label>
                    </div>
                  </div>

                  <div class="row margin-left-0px margin-right-0px">
                    <div class="col-print-12 text-center">
                      <label class="margin-bottom-0px margin-top-0px font-family font-weight-bold">3</label>
                    </div>
                  </div>
                </div>
                <div class="col-print-4 padding-left-10px">
                  <div class="row margin-left-0px margin-right-0px">
                    <div class="col-print-12 text-center">
                      <label class="margin-bottom-0px margin-top-0px font-family font-weight-normal">Grade</label>
                    </div>
                  </div>
                  <div class="row margin-left-0px margin-right-0px">
                    <div class="col-print-12 text-center">
                      <label class="margin-bottom-0px margin-top-0px font-family font-weight-bold">AA</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row margin-left-0px padding-top-10px padding-bottom-10px">
                <div class="col-print-11 text-center">
                  <img class="nav-link-hand img5" src="Day-5-Embryo.jpg">
                </div>
              </div>
              <div class="row margin-left-0px border-top-1px margin-right-0px">
                <div class="col-print-12 text-center">
                  <label class="margin-bottom-0px margin-top-0px font-family font-weight-normal">Frozen</label>
                </div>
              </div>
            </div>-->
          </div>
          <!--<div class="row margin-left-0px">
            <div class="col-print-1"></div>
            <div class="col-print-9">
              <div class="table-component margin-bottom-0px border4">
                <div class="table-responsive">
                  <table class="table table-striped margin-left-zero">

                    <tr>
                      <td class="font-family padding-top-2px padding-bottom-2px text-align-center">Well#<br />2</td>
                      <td class="font-family padding-top-2px padding-bottom-2px text-align-center">Day[1]<br />Grade: A <br />Status: [F] [D]</td>
                      <td class="font-family padding-top-2px padding-bottom-2px text-align-center">
                        <img class="nav-link-hand img5" src="Day-5-Embryo.jpg">
                      </td>
                    </tr>
                    <tr>
                      <td class="font-family padding-top-2px padding-bottom-2px text-align-center">Well#<br />2</td>
                      <td class="font-family padding-top-2px padding-bottom-2px text-align-center">Day[1]<br />Grade: A <br />Status: [F] [D]</td>
                      <td class="font-family padding-top-2px padding-bottom-2px text-align-center">
                        <img class="nav-link-hand img5" src="Day-5-Embryo.jpg">
                      </td>
                    </tr>

                  </table>

                </div>
              </div>
            </div>
          </div>-->
        </div>
        <div class="col-print-12">
          <div class="row margin-left-0px">
            <div class="col-print-2">
              <label class="margin-bottom-0px font-family font-weight-normal"></label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
            </div>
          </div>
        </div>
        <div class="col-print-12">
          <div class="row margin-left-0px">
            <div class="col-print-3">
              <label class="margin-bottom-0px font-family font-weight-bold">Total: {{TotalCout}}</label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
            </div>
          </div>
        </div>
        <div class="col-print-12">
          <div class="row margin-left-0px">

            <div class="col-print-7">
              <div class="table-component margin-bottom-0px border4">
                <div class="table-responsive">
                  <table class="table table-striped margin-left-zero">
                    <tr>
                      <th class="font-weight-normal background-primary padding-top-2px text-align-center padding-bottom-2px font-family">
                        Frozen
                      </th>

                      <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family text-align-center">
                        Discarded
                      </th>

                      <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family">
                        Continuing
                      </th>

                    </tr>
                    <tr>
                      <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{FrozenCount}}</td>
                      <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{DiscardedCount}}</td>
                      <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{TransferedCount}}</td>
                    </tr>

                  </table>

                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-print-12">
          <div class="row margin-left-0px">
            <div class="col-print-2">
              <label class="margin-bottom-0px font-family font-weight-normal"></label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
            </div>
          </div>
        </div>
        <div class="col-print-12">
          <div class="row margin-left-0px">
            <div class="col-print-2">
              <label class="margin-bottom-0px font-family font-weight-bold">Embryo Storage</label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
            </div>
          </div>
        </div>

        <div class="col-print-12">
          <div class="row margin-left-0px">
            <div class="col-print-7">
              <div class="table-component margin-bottom-0px border4">
                <div class="table-responsive">
                  <table class="table table-striped margin-left-zero">
                    <thead>
                      <tr>

                        <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family width-35px text-align-center">
                          Well#
                        </th>

                        <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family">
                          Grade
                        </th>
                        <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family">
                          Storage
                        </th>
                        <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family">
                          Details
                        </th>
                        <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family">
                          Status
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let l of CurrentIvfOocyteEmbryoStorageByCodeController">
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{l.WellNo}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{l.Grade}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{l.StorageUnitType}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{l.StorageUnitDetails}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{l.Status}}</td><!--{{l.RecordStatus}}-->
                      </tr>
                    </tbody>
                  </table>

                </div>
              </div>
            </div>
          </div>
        </div>

        <!--<div class="col-print-12">
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family"></label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family"></label>
            </div>
          </div>
        </div>
        <div class="col-print-12">
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-7">
              <label class="margin-bottom-0px font-family">Surgeon</label>
            </div>
            <div class="col-print-5">
              <label class="margin-bottom-0px font-family">Assistant Surgeon</label>
            </div>
          </div>
        </div>
        <div class="col-print-12">
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family"></label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family"></label>
            </div>
          </div>
        </div>
        <div class="col-print-12">
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-7">
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-4 border-bot-1px">
                  <label class="margin-bottom-0px font-family text-align-center"></label>
                </div>
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family"></label>
                </div>
              </div>
            </div>
            <div class="col-print-5">
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-6 border-bot-1px">
                  <label class="margin-bottom-0px font-family text-align-center"></label>
                </div>
                <div class="col-print-5">
                  <label class="margin-bottom-0px font-family"></label>
                </div>
              </div>
            </div>
          </div>
        </div>-->

      </div>
    </div>
  </div>
</div>
<!--<printfooterview></printfooterview>-->
